module.exports = __webpack_public_path__ + "static/media/twitter.3189d1e8.png";